import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, calculateStripeFee } from "@stripe/stripe-js";
import LoadingIndicator from "./LoadingIndicator";
import StripePayment from "./StripePayment";

const StripeProvider = ({ registrationID, paymentAmount }) => {
  const [stripe, setStripe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const prepareStripe = async () => {
      try {
        const baseUrl = window.location.href.split("?")[0];
        const fetchUrl = baseUrl.endsWith("/") ? `${baseUrl}getStripePublishableKey` : `${baseUrl}/getStripePublishableKey`;
        const response = await fetch(fetchUrl);
        const data = await response.json();
        if (data.publishableKey) {
          const stripeInstance = await loadStripe(data.publishableKey);
          setStripe(stripeInstance);
          setLoading(false);
        } else {
          setError("Failed to retrieve the Stripe key from the server.");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching Stripe key:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    prepareStripe();
  }, []);

  const stripeCentsFee = 30;
  const stripePercentageFee = 2.7;
  const paymentAmountCents = paymentAmount * 100;
  const total = (paymentAmountCents + stripeCentsFee) / (1 - stripePercentageFee / 100);
  const stripefeeCents = total - paymentAmountCents;
  const amount = Math.round(paymentAmountCents + stripefeeCents);
  console.log("paymentAmount", paymentAmount, "total", total, "stripefeeCents", stripefeeCents, "amount", amount);

  // Set up payment options
  const options = {
    mode: "payment",
    amount: amount,
    currency: "nzd",
  };

  // Render loading, error, or the form based on the state
  if (loading) {
    return <LoadingIndicator message="Preparing payment..." />;
  }

  if (error) {
    return <div className="error">{`Error: ${error}`}</div>;
  }

  return (
    <div className="c-event-registration-form__payment-wrapper">
      <Elements stripe={stripe} options={options}>
        <h3 className="c-event-registration-form__heading">Pay with Stripe</h3>
        <p>
          <small className="c-event-registration-form__total-price">
            Total to pay: <strong>${(amount / 100).toFixed(2)} NZD</strong> (includes Stripe fees of ${(stripefeeCents / 100).toFixed(2)} NZD - 2.7% + NZ$0.30)
          </small>
        </p>
        <StripePayment registrationID={registrationID} />
      </Elements>
    </div>
  );
};

export default StripeProvider;
